var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrustpilotLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5419 9.92379H17.0246L13.776 0L10.5173 9.92379L0 9.91373L8.51739 16.0532L5.25865 25.9669L13.776 19.8375L22.2833 25.9669L19.0347 16.0532L27.5419 9.92379Z",
    fill: "#00B67A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrustpilotLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trustpilot-logo.fc1ed2f141a68dd2418409700bce09e5.svg";